import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';

const state = {
  articleTopLine: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_ARTICLE_TOP_LINE_BUSY: (state, payload) => {
    state.articleTopLine.isBusy = payload;
  },
  LOAD_ARTICLE_TOP_LINE_SUCCESS: (state, payload) => {
    state.articleTopLine.data = payload.data;
    state.articleTopLine.error = null;
  },
  REFRESH_METRICS_SUCCESS: (state, payload) => {
    state.articleTopLine.data = {...payload.data, impressions: payload.data.impressions, ave: payload.data.ave};
    state.articleTopLine.error = null;
  },
  REFRESH_SUMMARY: (state, payload) => {
    state.articleTopLine.data.summary = payload;
    state.articleTopLine.error = null;
  },
  LOAD_ARTICLE_TOP_LINE_FAIL: (state, payload) => {
    // state.articleTopLine.data = null;
    state.articleTopLine.error = payload;
  }
};

const getters = {
  summary: state => {
    if (
      !state.articleTopLine.data ||
      !state.articleTopLine.data.summary
    ) return '';

    return state.articleTopLine.data.summary;
  },
}

const actions = {
  getArticleTopLine: ({ commit, rootState }, { projectId, articleId }) => {
    commit('LOAD_ARTICLE_TOP_LINE_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/top_line/${articleId}`, config)
      .then((response) => {
        commit('LOAD_ARTICLE_TOP_LINE_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_ARTICLE_TOP_LINE_FAIL', error)
      })
      .finally(() => commit('LOAD_ARTICLE_TOP_LINE_BUSY', false));
  },

  refreshSummary({ commit }, newValue) {
    commit('REFRESH_SUMMARY', newValue);
  },

  updateArticleTopLine: ({ commit, rootState }, { projectId, articleId, topLine, requestSave }) => {
    if (requestSave) {
      commit('LOAD_ARTICLE_TOP_LINE_BUSY', true);

      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };

      Axios
        .put(`${API_HOST}/analysis/editor/${projectId}/top_line/${articleId}`, topLine, config)
        .then(response => {
          commit('LOAD_ARTICLE_TOP_LINE_SUCCESS', response.data)
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });
          console.error(error); //
          commit('LOAD_ARTICLE_TOP_LINE_FAIL', error) //
        }) //
        .finally(() => commit('LOAD_ARTICLE_TOP_LINE_BUSY', false)); //
    } else {
      const data = Object.assign(JSON.parse(JSON.stringify(rootState.articleTopLine)), topLine);
      commit('LOAD_ARTICLE_TOP_LINE_SUCCESS', { data });
    }
  },
        //console.error(error);
        //commit('LOAD_ARTICLE_TOP_LINE_FAIL', error)
      //})
      //.finally(() => commit('LOAD_ARTICLE_TOP_LINE_BUSY', false));
  //}, now has else after as in } else ....

  
  refreshArticleTopLineMetrics: ({ commit, rootState }, { projectId, articleId, topLine }) => {
    commit('LOAD_ARTICLE_TOP_LINE_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .put(`${API_HOST}/analysis/editor/${projectId}/top_line/refresh/${articleId}`, topLine, config)
      .then(response => {
        commit('REFRESH_METRICS_SUCCESS', response.data);
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('messages.request.refresh_metrics_success')
        });
      }).catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});
        console.error(error);
        commit('LOAD_ARTICLE_TOP_LINE_FAIL', error)
      })
      .finally(() => commit('LOAD_ARTICLE_TOP_LINE_BUSY', false));
  }

  // updateTranslations: ({ commit, rootState }, { projectId, articleId }) => {
  //   commit('LOAD_ARTICLE_TOP_LINE_BUSY', true);

  //   const { accessToken } = rootState.user.user.data;
  //   const config = {
  //     headers: { Authorization: `Token token=${accessToken}` }
  //   };
  //   Axios
  //     .post(`${API_HOST}/analysis/editor/${projectId}/translations/${articleId}`, {}, config)
  //     .then(response => {
  //       console.log('response', rootState.articleTopLine.articleTopLine.data, response.data.data);
  //       const data = Object.assign(JSON.parse(JSON.stringify(rootState.articleTopLine.articleTopLine.data), response.data.data));
  //       commit('LOAD_ARTICLE_TOP_LINE_SUCCESS', { data });
  //     })
  //     .catch(error => {
  //       Vue.notify({
  //         group: 'store_notifications',
  //         type: 'error',
  //         text: i18n.t('messages.request.error')
  //       });
  //       console.error(error);
  //       commit('LOAD_ARTICLE_TOP_LINE_FAIL', error)
  //     })
  //     .finally(() => commit('LOAD_ARTICLE_TOP_LINE_BUSY', false));
  // }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};